import { render, staticRenderFns } from "./TicketSystemSettings.vue?vue&type=template&id=6c9e710e"
import script from "./TicketSystemSettings.vue?vue&type=script&lang=js"
export * from "./TicketSystemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports